import React from 'react';

import { clsx } from '@interlayer/js/utils/classNames.util';

import { getCellConfiguration } from './helpers';

import style from './index.scss';

type BaccaratCellProps = {
    cell: string;
}

const BaccaratCell: React.FC<BaccaratCellProps> = React.memo(({ cell }) => {
    const config = getCellConfiguration(cell);

    return (
        <div className={clsx([style.resultTableCell, ...config.classes])}>
            {config.tiesCount > 1 ? config.tiesCount : ''}
        </div>
    );
});

export default BaccaratCell;
